import { createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '@data-phone/react-resource-server-auth';

export interface CallCenterAgent {
  name: string;
  extension: string;
  description: string;
}

export const fetchCallCenterAgents = createAsyncThunk<CallCenterAgent[]>(
  'callCenterAgents/fetchCallCenterAgents',
  async () => {
    const response = await api.get(`${process.env.REACT_APP_LIVE_CALL_URL}/api/callcenter/agents`);
    const result = response.result;
    return result as CallCenterAgent[]
  }
);
